exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-alert-v2.ant-alert{border:none;font-size:12px;padding-left:.857rem;padding-right:.857rem}.cap-alert-v2.ant-alert.ant-alert-success{background-color:#dbefda}.cap-alert-v2.ant-alert.ant-alert-info{background-color:#fff4d6}.cap-alert-v2.ant-alert.ant-alert-warning{background-color:#fee5d3}.cap-alert-v2.ant-alert.ant-alert-error{background-color:#fbd3d8}\n", ""]);

// exports
